import { formatCurrencyFromCentsAndRound } from '@/utils/currencyHelpers'
export enum AnnualTaxFilingStepStatus {
  upcoming = 'upcoming',
  comingSoon = 'coming-soon',
  notStarted = 'not-started',
  inProgress = 'in-progress',
  readyForReview = 'ready-for-review',
  readyToSign = 'ready-to-sign',
  completeLocked = 'complete-locked',
  completeUnlocked = 'complete-unlocked',
}

export enum TaxChecklistPaths {
  checkYourDetails = 'check-your-details',
  checkYourDetailsReadOnly = `${checkYourDetails}?screen=review`,
  checkYourDetailsPersonal = 'check-your-details/personal',
  checkYourDetailsPersonalReadOnly = `${checkYourDetailsPersonal}?screen=review`,
  documents = 'documents',
  documentsReadOnly = `${documents}?screen=review`,
  addMissingQtePayments = 'add-missing-qte-payments',
  addMissingQtePaymentsReadOnly = `${addMissingQtePayments}?screen=review`,
  lifeChanges = 'life-changes',
  lifeChangesReadOnly = `${lifeChanges}?screen=review`,
  deductionsAndCredits = 'deductions-and-credits',
  deductionsAndCreditsReadOnly = `${deductionsAndCredits}?screen=review`,
  incomeAndLiabilities = 'income-and-liabilities',
  incomeAndLiabilitiesReadOnly = `${incomeAndLiabilities}?screen=review`,
  payments = 'payments',
}

export const ADDITIONAL_1040_COST = 450

export const TAXFYLE_PORTAL_TRY_AGAIN_ERROR =
  "We couldn't open the link. Please try again in a few seconds."

export const TAXFYLE_PORTAL_CONTACT_SUPPORT_ERROR =
  "We couldn't open this link. Please contact support for help."

/** The amount paid to a contractor in a year that requires a 1099-NEC. */
export const FORM_1099_NEC_THRESHOLD_DISPLAY = formatCurrencyFromCentsAndRound(
  60000,
  { hideDecimalsIfZero: true }
)

const FIRST_TAX_YEAR_WITH_2000_1099_NEC_THRESHOLD = 2026

/** The amount paid to a contractor in a tax year that requires a 1099-NEC. */
export const get1099NecThresholdDisplay = (taxYear: string): string =>
  formatCurrencyFromCentsAndRound(
    Number(taxYear) >= FIRST_TAX_YEAR_WITH_2000_1099_NEC_THRESHOLD
      ? 200000
      : 60000,
    { hideDecimalsIfZero: true }
  )

export const CONTRACTOR_FILING_QUESTIONNAIRE_PATH = '/taxes/annual/1099-nec'

/** 1099 jobs for this tax year and earlier live in Taxfyle's read-only contractor workspace. */
export const LAST_CONTRACTOR_WORKSPACE_TAX_YEAR = 2025

export const isContractorWorkspaceTaxYear = (taxYear: string): boolean =>
  Number(taxYear) <= LAST_CONTRACTOR_WORKSPACE_TAX_YEAR
